// Appends hash if hash is available
export default (pathname: string, hash?: string) =>
  hash ? `${pathname}#${hash}` : pathname;
